// extracted by mini-css-extract-plugin
module.exports = {"container":"overlay__container--2_LE4","isActive":"overlay__isActive--1MwpG","icon":"overlay__icon--38eV-"};
    if(module.hot) {
      // 1546575116661
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  